<div class="content" mat-dialog-close>
  <div class="close" mat-dialog-close>
    <img
      alt="close"
      width="24"
      height="24"
      src="../../../../assets/images/close.svg"
    />
  </div>
  <img src="../../../assets/images/holiday/modal.png" alt="" />
</div>
